const options = {
  5: "bg-orange-600/5",
  10: "bg-orange-600/10",
  25: "bg-orange-600/25",
  50: "bg-orange-600/50",
  75: "bg-orange-600/75",
  90: "bg-orange-600/90",
  100: "bg-orange-600",
};

const from = {
  5: "from-orange-600/5",
  10: "from-orange-600/10",
  25: "from-orange-600/25",
  50: "from-orange-600/50",
  75: "from-orange-600/75",
  90: "from-orange-600/90",
  100: "from-orange-600",
};

export default function getBackgroundOrange600(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
